import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { content: String, small: Boolean }

    connect() {
        this.insertContentIntoSelf()
    }

    baseClasses = ["text-wrap", "custom-text", "text-black"]
    wrapClasses = ["whitespace-pre-line", "leading-none", "align-top"]
    titleClasses = ["xl:text-[4.25rem]", "lg:text-[2.8125rem]", "md:text-[2.5rem]", "text-[1.625rem]"]
    preClasses = ["whitespace-pre"]
    smallTitleClasses = ["lg:text-[1.25rem]", "text-[1.125rem]"]
    bodyClasses = ["xl:text-[1.875rem]", "lg:text-[1.25rem]", "md:text-[1.125rem]", "text-[1rem]"]
    smallBodyClasses = ["text-[1.125rem]"]
    smallUnderlineClasses = ["lg:text-[1.25rem]", "whitespace-nowrap"]
    underlineClasses = ["xl:text-[1.875rem]", "lg:text-[1.25rem]", "md:text-[1.125rem]", "text-[1rem]"]

    insertContentIntoSelf() {
        if (!this.contentValue) {
            setTimeout(() => this.insertContentIntoSelf(), 50)
            return
        }

        const temp = document.createElement('div')
        temp.innerHTML = this.contentValue

        this.setTitle("h1 strong", temp)
        this.setTitle("h1", temp)
        temp.querySelectorAll('a').forEach(function (link) {
            link.target = "_blank"
        })

        this.setBody("div", temp)
        this.setPre("pre", temp)

        this.styleBrOnlyDivs(temp)
        this.element.innerHTML = temp.innerHTML
    }

    styleBrOnlyDivs(container) {
        const divElements = container.querySelectorAll("div")

        divElements.forEach(div => {
            const children = Array.from(div.childNodes).filter(node =>
                node.nodeType === Node.ELEMENT_NODE ||
                (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '')
            )

            if (children.length === 1 && children[0].tagName === 'BR') {
                div.className = ''
                div.classList.add("max-h-3")
            }
        })
    }

    setPre(classNames, temp) {
        const targets = temp.querySelectorAll(classNames)
        targets.forEach(el => {
            if (!el.classList.contains("arc-title")) {
                let lines = el.textContent.split('\n')

                if (lines.some(line => line.includes('|'))) {
                    const columns = lines.map(line => line.split('|').map(col => col.trim()))

                    const table = document.createElement('table')
                    table.classList.add('w-full', 'border-collapse', 'custom-text', ...this.bodyClasses)

                    const tbody = document.createElement('tbody')

                    columns.forEach(cols => {
                        const tr = document.createElement('tr')
                        cols.forEach((col, i) => {
                            const td = document.createElement('td')
                            td.textContent = col
                            if (i === 0) {
                                td.classList.add('text-left', 'pr-8', 'align-top')
                            } else {
                                td.classList.add('text-right', 'align-top')
                            }

                            tr.appendChild(td)
                        })
                        tbody.appendChild(tr)
                    })

                    table.appendChild(tbody)
                    el.replaceWith(table)
                }
            }
        })
    }


    setBody(classNames, temp) {
        const targets = temp.querySelectorAll(classNames)
        targets.forEach(el => {
            if (!el.classList.contains("arc-title")) {
                el.classList.add(...this.baseClasses)

                if (this.smallValue) {
                    el.classList.add(
                        ...this.smallBodyClasses
                    )
                    const underlineElements = el.querySelectorAll('u');
                    underlineElements.forEach(u => {
                        u.classList.add(
                            ...this.smallUnderlineClasses
                        );
                    });
                } else {
                    const underlineElements = el.querySelectorAll('u');
                    underlineElements.forEach(u => {
                        u.classList.add(
                            ...this.underlineClasses
                        );
                    });
                    el.classList.add(
                        ...this.bodyClasses,
                        ...this.wrapClasses
                    )
                }
            }
        })
    }

    setTitle(classNames, temp) {
        const h1Elements = temp.querySelectorAll(classNames)

        h1Elements.forEach(h1 => {
            const span = document.createElement("span")

            span.innerHTML = h1.innerHTML

            span.classList.add(
                ...this.baseClasses,
                "arc-title",
            )
            if (this.smallValue) {
                span.classList.add(...this.smallTitleClasses)
            }
            else {
                span.classList.add(
                    ...this.titleClasses,
                    ...this.wrapClasses
                )
            }

            h1.replaceWith(span)
        })
    }

}
